import { ProjectView } from '@lemoncloud/codes-goods-api';
import { create } from 'zustand';

import { useProjectService } from './useProjectService';

interface ProjectSettingDialogState {
    isOpen: boolean;
    projectId: string | null;
    open: (projectId: string) => void;
    close: () => void;
}

const useProjectSettingDialogStore = create<ProjectSettingDialogState>(set => ({
    isOpen: false,
    projectId: null,
    open: (projectId: string) => set({ isOpen: true, projectId }),
    close: () => set({ isOpen: false }),
}));

export const useProjectSettingDialog = () => {
    const { isOpen, projectId, open, close } = useProjectSettingDialogStore();
    const { myProjects } = useProjectService();

    const project = projectId ? (myProjects?.find(p => p.id === projectId) as ProjectView) : null;

    return {
        isOpen,
        project,
        open,
        close,
    };
};
